import iconNames from './material-icons.json'

export const getIconsList = () => iconNames
